module.exports = __webpack_public_path__ + "img/mon_64.96bae148.png";